import { create } from "zustand";

export interface GlobalFeatureFlags {
  serverPagination: boolean;
  enableDynamicQuestionAndResponse: boolean;
  enableEsign: boolean;
  enableControlledLifecycleValidation?: boolean;
  enableRegulatoryStatus?: boolean;
  enableRegulatoryStatusTransition?: boolean;
  enableHaqImport?: boolean;
  dynamic_wizard?: boolean;
}

interface ServerPaginationStore extends GlobalFeatureFlags {
  updateServerPagination: (newVal: boolean) => void;
  updateEnableDynamicQuestionAndResponse: (newVal: boolean) => void;
  setGlobalFeatureFlags: (
    partial: Partial<GlobalFeatureFlags> & Record<string, boolean | undefined>,
  ) => void;
}

const useGlobalFeatureFlag = create<ServerPaginationStore>((set) => ({
  serverPagination: true,
  updateServerPagination: (newVal) => set(() => ({ serverPagination: newVal })),
  enableDynamicQuestionAndResponse: true,
  updateEnableDynamicQuestionAndResponse: (newVal) =>
    set(() => ({ enableDynamicQuestionAndResponse: newVal })),
  enableEsign: false,
  setGlobalFeatureFlags: (partial) =>
    set((state) => ({
      ...state,
      ...partial,
    })),
}));

export default useGlobalFeatureFlag;
